import { formatCurrency } from '@apply/ui';
import { BrokerAgreementBorrower } from '../../../../../../../queries/brokerAgreementQueries';

/** The agreement borrower's regular and adjusted net worth, or "Not set". */
export const BorrowerNetWorth = ({ borrower }: { borrower: BrokerAgreementBorrower }) => {
    return (
        <div style={{ flex: '1 1 0', minWidth: 0 }}>
            <div>
                <b>Net Worth</b>
            </div>
            <div>Regular: {borrower.netWorth ? formatCurrency(borrower.netWorth, 0) : 'Not set'}</div>
            <div>
                Adjusted: {borrower.adjustedNetWorth ? formatCurrency(borrower.adjustedNetWorth, 0) : 'Not set'}
            </div>
        </div>
    );
};
